import React from 'react';
import { RefreshControl, RefreshControlProps } from 'react-native';

import { usePullToRefresh } from '@/hooks/use-pull-to-refresh';

interface EnhancedRefreshControlProps extends Omit<RefreshControlProps, 'refreshing' | 'onRefresh'> {
	refreshing?: boolean;
	onRefresh?: () => void;
	useEnhancedProps?: boolean; // Whether to use iPad-optimized props
}

/**
 * Enhanced RefreshControl component with iPad-specific optimizations
 * Provides better touch sensitivity and visual feedback on iPad devices
 */
export const EnhancedRefreshControl: React.FC<EnhancedRefreshControlProps> = ({
	refreshing,
	onRefresh,
	useEnhancedProps = true,
	...otherProps
}) => {
	const { getRefreshControlProps } = usePullToRefresh();

	// Get enhanced props if requested and available
	const enhancedProps = useEnhancedProps ? getRefreshControlProps() : {};

	// Merge props: enhanced props first, then other props, then required props
	const finalProps = {
		...enhancedProps,
		...otherProps,
		refreshing: refreshing ?? (enhancedProps as any).refreshing,
		onRefresh: onRefresh ?? (enhancedProps as any).onRefresh,
	};

	return <RefreshControl {...finalProps} />;
};
